import React, { FunctionComponent } from 'react'

import styled, { useTheme } from 'styled-components/native'

import { IS_WEB } from '../constants'

const TabItemIconContainer = styled.View({
  alignItems: 'center',
  height: !IS_WEB ? '100%' : 'auto',
})

const ActiveTabHighlight = styled.View<{ isActive: boolean }>(({ theme, isActive }) => ({
  width: '64px',
  height: '2px',
  marginBottom: theme.spacing['8px'],
  backgroundColor: isActive ? theme.colors.backgroundActive : theme.colors.backgroundPrimary,
  borderRadius: theme.spacing['16px'],
}))

const TabItemIcon: FunctionComponent<{ children: React.ReactNode; isActive: boolean }> = ({ children, isActive }) => {
  return (
    <TabItemIconContainer>
      <ActiveTabHighlight isActive={isActive} />
      {children}
    </TabItemIconContainer>
  )
}

export const getTabItemIcon = ({
  isActive,
  IconComponent,
  testID,
}: {
  isActive: boolean
  IconComponent: React.ComponentType<{ fillColor?: string; testID?: string }>
  testID: string
}) => {
  const { colors } = useTheme()

  return (
    <TabItemIcon isActive={isActive}>
      <IconComponent
        fillColor={isActive ? colors.iconActive : colors.iconDefault}
        testID={`${testID}${isActive ? '-focused' : ''}`}
      />
    </TabItemIcon>
  )
}
